import get from 'lodash/get';
import triggerTracking from '@blueprint/tracking';
import { ListingResponse } from '../Listings/Listings.types';
import { isProperty } from '../helpers';
import { PropertyOrPromoItem } from '../helpers/featuredProperties';
import { ProductTrackingObject } from 'search/SearchContext';

const getVariant = (featuredType: ListingResponse['featuredType']): string => {
    const featuredTypeToVariant = {
        featured: 'Featured',
        weekly_featured: 'Weekly Featured'
    };

    const defaultVariant = featuredTypeToVariant.featured;

    return get(featuredTypeToVariant, featuredType ?? '', defaultVariant);
};

const getPromoCategory = (item: string) => {
    const promoTypeToCategory = {
        mobile: 'app_in_wfp',
        smartmap: 'map_in_wfp',
        newhomes: 'nh_in_wfp'
    };

    return get(promoTypeToCategory, item);
};

export const getProductImpression = (
    item: PropertyOrPromoItem,
    position: number,
    listName = 'Featured listings'
): ProductTrackingObject =>
    isProperty(item)
        ? ({
              id: item.listingId,
              list: listName,
              position: position,
              variant: getVariant(item.featuredType)
          } as ProductTrackingObject)
        : ({
              id: 'Unfilled',
              list: listName,
              position: position,
              variant: item
          } as ProductTrackingObject);

export const trackFeaturedPropertyImpressions = (
    displayedItems: PropertyOrPromoItem[]
): void => {
    const impressions = displayedItems
        .map((item, index) => getProductImpression(item, index + 1))
        .filter((impression) => impression.id === 'Unfilled');

    triggerTracking({
        event: 'GAEventEcommerce',
        ecommerce: {
            impressions
        }
    });
};

export const getOnClickTracking =
    (item: PropertyOrPromoItem, index: number): (() => void) =>
    () => {
        if (isProperty(item)) {
            const { id, list, position, variant } = getProductImpression(
                item,
                index + 1
            );
            triggerTracking({
                event: 'GAEventEcommerce',
                ecommerce: {
                    click: {
                        actionField: {
                            list
                        },
                        products: [
                            {
                                id,
                                position,
                                variant
                            }
                        ]
                    }
                }
            });
        } else {
            const eventCategory = getPromoCategory(item);
            triggerTracking({
                event: 'GAEvent',
                eventAction: 'Click',
                eventCategory
            });
        }
    };
